// Words and widgets shared across many app areas (language switcher, generic labels).
const common = {
  appName: "BlogToStart",
  language: {
    label: "Language",
    choose: "Choose a language",
    automatic: "Automatic (browser language)",
    changed: "Language updated.",
    en: "English",
    fr: "French",
    ar: "Arabic",
  },
  viewAll: "View all",
  learnMore: "Learn more",
  back: "Back",
  continue: "Continue",
  optional: "optional",
  you: "You",
  on: "On",
  off: "Off",
  yes: "Yes",
  no: "No",
  errorBoundary: {
    title: "Something went wrong",
    body: "This page hit an unexpected error. The problem has been reported to the team.",
    retry: "Try again",
    home: "Back to the dashboard",
    reference: "Reference:",
  },
};
export default common;
